var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeave = function SvgLeave(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 3.33594V12.6693C13.3332 13.7739 12.4378 14.6693 11.3332 14.6693H4.6665C3.56184 14.6693 2.6665 13.7739 2.6665 12.6693V3.33594C2.6665 2.23127 3.56184 1.33594 4.6665 1.33594H11.3332C12.4378 1.33594 13.3332 2.23127 13.3332 3.33594Z",
    fill: "#C5C9CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66406H7.33333C6.59667 6.66406 6 7.26073 6 7.9974C6 8.73406 6.59667 9.33073 7.33333 9.33073H12V6.66406Z",
    fill: "#8F979A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0527 10.7511C11.0527 11.2651 11.6727 11.5238 12.0381 11.1618L14.6334 8.59112C14.9634 8.26379 14.9634 7.73046 14.6334 7.40312L12.0381 4.83246C11.6727 4.47112 11.0527 4.72979 11.0527 5.24312V10.7511Z",
    fill: "#8F979A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "leave.fe7a5b3ee3e4383fde53aac6cb5429ee.svg";